import { render, staticRenderFns } from "./RecurrencyPopForm.vue?vue&type=template&id=ca24d282&scoped=true"
import script from "./RecurrencyPopForm.vue?vue&type=script&lang=js"
export * from "./RecurrencyPopForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca24d282",
  null
  
)

export default component.exports